import { render, staticRenderFns } from "./ShowNavegantes.vue?vue&type=template&id=a7c22746"
import script from "./ShowNavegantes.vue?vue&type=script&lang=js"
export * from "./ShowNavegantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports